module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/288_symbol_8@3x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-paytable/288_symbol_8@3x.png
// module id = 673
// module chunks = 0